import { computed } from 'vue'

export function useButtonClasses(props) {
  const staticClasses =
    'inline-flex items-center font-medium shadow-sm transition-width duration-300 ease-in-out'

  const sizeClasses = computed(() => {
    if (props.shape == 'rounded') {
      if (props.size == 'xs') return 'px-3 py-1.5 text-xs'
      else if (props.size == 'sm') return 'px-3.5 py-2 text-sm'
      else if (props.size == 'md') return 'px-4 py-2 text-sm'
      else if (props.size == 'lg') return 'px-5 py-2 text-base'
      else return 'px-6 py-3 text-base'
    } else if (props.shape == 'circular') {
      if (props.size == 'xs') return 'p-1'
      else if (props.size == 'sm') return 'p-1.5'
      else if (props.size == 'md') return 'p-2'
      else if (props.size == 'lg') return 'p-2'
      else return 'p-3'
    } else if (props.shape === 'default') {
      if (props.size == 'xs') return 'px-2.5 py-1.5 text-xs'
      else if (props.size == 'sm') return 'px-3 py-2 text-sm leading-4'
      else if (props.size == 'md') return 'px-4 py-2 text-sm'
      else if (props.size == 'lg') return 'px-4 py-2 text-base'
      else if (props.size == 'modal') return 'px-4 py-2 text-base sm:text-sm'
      // 'modal' is same as 'md' except text-base and sm:text-sm
      else return 'px-6 py-3 text-base'
    } else {
      return props.shape
    }
  })

  const colorClasses = computed(() => {
    if (props.color == 'white')
      return 'text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-gray-100'
    else if (props.color == 'secondary')
      return 'text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:text-indigo-200 dark:bg-indigo-900 dark:hover:bg-indigo-800'
    else if (props.color == 'red')
      return 'text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 dark:text-red-200 dark:bg-red-800 dark:hover:bg-red-700'
    else
      return 'text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:text-white dark:bg-indigo-700 dark:hover:bg-indigo-600'
  })

  const shapeClasses = computed(() => {
    return props.shape == 'rounded' || props.shape === 'circular'
      ? 'rounded-full'
      : ''
  })

  const roundedClasses = computed(() => {
    if (props.shape == 'default') {
      if (props.rounded == 'left') return 'focus:z-10 rounded-l-md'
      else if (props.rounded == 'right') return 'focus:z-10 rounded-r-md'

      if (props.size == 'xs') return 'rounded'
      else return 'rounded-md'
    }
  })

  const borderClasses = computed(() => {
    let borderLocation = ''
    let borderColor = ''

    // For 'right' rounded buttons, don't show border on left side, as that border will be taken care by the next button in the button group
    if (props.rounded == 'right') borderLocation = 'border-t border-b border-r'
    else borderLocation = 'border'

    if (props.color == 'white') {
      borderColor = 'border-gray-300 dark:border-gray-400'
    } else {
      if (props.rounded == 'left') {
        // For left rounded, apply a right border

        borderColor =
          'border-t-transparent border-b-transparent border-l-transparent'

        // Because by default these colors use a transparent border, need to specifically add a colored border to the right side to show where the button group splits
        if (props.color == 'secondary')
          borderColor += ' border-r-red-300 dark:border-r-red-400'
        else if (props.color == 'red')
          borderColor += ' border-r-red-300 dark:border-r-red-400'
        else borderColor += ' border-r-indigo-300 dark:border-r-indigo-400'
      } else {
        borderColor = 'border-transparent'
      }
    }

    return [borderLocation, borderColor].join(' ')
  })

  const disabled = computed(() => props.disabled || props.processing)

  const disabledClasses = computed(() => (disabled.value ? 'opacity-30' : ''))

  return computed(() =>
    [
      staticClasses,
      sizeClasses.value,
      colorClasses.value,
      shapeClasses.value,
      roundedClasses.value,
      borderClasses.value,
      disabledClasses.value,
    ].join(' ')
  )
}
